module.exports = __webpack_public_path__ + "assets/img/hover_sukikamo.00a3b8d7.svg";